import React from "react";
import { Link } from 'react-router-dom';
import {getRadius} from '../../../helper';

export default (props) => {

    const {
        handleOnChange,
        handleCancel,
        onSubmit,

        state,
        title,
        comment,
        latitude,
        longitude,
        radius,
        isFetching,
        errorMessages,
    } = props;

	return(
        <div className="white-block-content" style={{padding: '15px 30px 0 30px'}}>
            <div style={{padding: '30px'}}>
                <form
                    onSubmit={(e) => isFetching ? false : onSubmit(e)}
                    >
                    <div style={{marginBottom:'25px'}}>
                        <h3 className="location-title">{`Заголовок: ${title}`}</h3>
                    </div>                    

                    <div style={{marginBottom:'25px'}}>
                        <h3 className="location-title">{`Адрес (координаты): широта ${latitude}, долгота ${longitude}`}</h3>
                    </div>

                    <div style={{marginBottom:'25px'}}>
                        <input
                            type="text"
                            placeholder="Комментарий к адресу (не обязательно)"
                            className="width100"
                            style={{height:'40px',}}
                            value={comment}
                            onChange={(e) => handleOnChange(e.target.value, 'comment')}
                        />
                        {
                            errorMessages && errorMessages.comment ?
                            <div style={{marginBottom:'10px'}} className="input-error-text etmt10">{errorMessages.comment}</div>
                            : null
                        }
                    </div>

                    <div style={{marginBottom:'25px'}}>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                            <input
                                style={{height:'40px', width: '150px'}}
                                type="number"
                                required
                                placeholder="Радиус"
                                min="0"
                                className="width100"
                                value={radius}
                                onChange={(e) => handleOnChange(e.target.value, 'radius')}
                            />

                            <div style={{fontWeight:'bold',marginLeft:'15px'}}>{getRadius(radius)}</div>
                        </div>

                        <div style={{fontStyle:'italic'}}>в метрах</div>

                        {
                            errorMessages && errorMessages.radius ?
                            <div style={{marginBottom:'10px'}} className="input-error-text etmt10">{errorMessages.radius}</div>
                            : null
                        }
                    </div>
                    
                    <div className="actions">
                        <div className="big-button empty-button">
                            {
                                state === "update" ?
                                <button onClick={(e) => handleCancel(e)}>Отмена</button>
                                :
                                <Link to="/account/locations">
                                    <button>Назад</button>
                                </Link>
                            }
                        </div>
                        {
                            <div className="big-button button-action">
                                <button
                                    disabled={isFetching ? true : false}
                                    className={isFetching ? 'disabled' : ''} >
                                    Сохранить
                                </button>
                            </div>
                        }
                    </div>
                </form>
                
                
            </div>
        </div>
	)
}


// WEBPACK FOOTER //
// ./src/components/Account/Locations/CreateFormTracker.js